/**
 * @file        src/pages/flight/CorporateDiscountList.jsx
 * @description Corporate Flight → Discount List. Same list/form as the B2C
 *              Flight Discount List (DiscountList.jsx), fixed to audience=b2b,
 *              instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Flight menu parity with B2C).
 */
import DiscountList from './DiscountList';

export default function CorporateDiscountList() {
  return (
    <DiscountList
      title="Corporate Discount List"
      subtitle="Corporate Flight · B2B airline-wise discounts"
      audience="b2b"
    />
  );
}
